import React, { useState } from 'react';

import ThemeProvider from './components/ThemeProvider';
import Container from './components/Container';
import CertificatesList from './components/CertificatesList';
import useCertificates from './hooks/useCertificates';
import { Box, Button } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import CertificatesFilters from './components/CertificatesFilters';

export default function ListCertificatesV2() {
  const {
    certificates,
    loading,
    page,
    limit,
    filters,
    onClearFilters,
    onSubmitFilters,
    changeLimit,
    changePage,
    refreshData
  } = useCertificates();

  const [openFilters, setOpenFilters] = useState(false);

  const handleSubmitFilters = (filters) => {
    setOpenFilters(false);
    onSubmitFilters(filters);
  }

  const handleClearFilters = () => {
    setOpenFilters(false);
    onClearFilters();
  }

  return (
    <ThemeProvider>
      <Container>
        <Box mb={2} display="flex" justifyContent="space-between">
          <Button variant="outlined" color="primary" onClick={() => setOpenFilters(prev => !prev)}>
            <FilterList />
            Filtros
          </Button>
          <Button variant="contained" color="primary" href="/admin/certificados/novo" target="_blank">Gerar novo certificado</Button>
        </Box>
        <CertificatesFilters
          open={openFilters}
          filters={filters}
          onClearFilters={handleClearFilters}
          onSubmitFilters={handleSubmitFilters}
        />
        <CertificatesList
          certificates={certificates}
          page={page}
          limit={limit}
          loading={loading}
          onChangePage={changePage}
          onChangeLimit={changeLimit}
          refreshData={refreshData}
        />
      </Container>
    </ThemeProvider>
  );
}